import { useState } from "react";
import KarmaCollectPayment from "../Components/KarmaCollectPayment";

const PaymentDetails = () => {
  const [showModal, setShowModal] = useState(false);

  const karmaServices = [
    { name: "Karma - Virechan", date: "01 Jan 2025", cost: 1200 },
    { name: "Karma - Vaman", date: "05 Jan 2025", cost: 1500 },
    { name: "Karma - Basti", date: "10 Jan 2025", cost: 1000 },
  ];

  return (
    <div className="card shadow-none">
      <div className="card-body">
      <div className="text-end mb-3">
        <button className="btn btn-sm btn-primary" onClick={() => setShowModal(true)}>
          Collect Payment
        </button>
        </div>
        <div className="row">
          {karmaServices.map((item, i) => (
            <div key={i} className="col-xl-12 mb-3">
              <div className="custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded d-flex justify-content-between align-items-center shadow-sm">
                <div>
                  <h6 className="fw-bold">{item.name}</h6>
                  <p className="mb-1 text-muted">Date: {item.date}</p>
                  <p className="mb-0 text-muted">Cost: ₹{item.cost}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Payment Modal */}
      <KarmaCollectPayment show={showModal} handleClose={() => setShowModal(false)} />
    </div>
  );
};

export default PaymentDetails;
